
class EventCategory {
    title: string;
    backgroundColor: string;
    textColor: string;
}

class CommunityEvent {
    nodeId: number;
    info: string;
    abstract: string;
    location: string;
    url: string;
    startDate: Date;
    endDate: Date;
    title: string;
    subtitle: string;
    name: string;
    openInNewWindow: boolean;
    category: EventCategory;
    constructor() { }
}

class ScheduleEvent {
    date: Date;
    name: string;
    startTime: Date;
    endTime: Date;
}

class RecurringCommunityEvent extends CommunityEvent {
    weekDays: string;
    startTime: Date;
    endTime: Date;
    schedules: ScheduleEvent[];
}

export const DateFields = ['startDate', 'endDate'];
export const RecurringDateFields = ['startDate', 'endDate', 'startTime', 'endTime'];

export { CommunityEvent, RecurringCommunityEvent }